import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Google Analytics (gtag) のページビューをトラッキングするコンポーネント。
 * React Router v6以降に対応。
 * @param {object} props - コンポーネントのプロパティ
 * @param {string} props.trackingId - GA4の測定ID (例: 'G-XXXXXXXXXX')
 */
const GATracker = ({ trackingId }) => {
  // 💡 URLの変更を監視
  const location = useLocation();

  useEffect(() => {
    // ページ遷移時、または初回マウント時に実行
    
    // window.gtag が存在するか確認 (public/index.html で読み込まれているはず)
    // 💡 .jsファイルでは 'window.gtag' の型定義エラーは発生しない
    if (window.gtag && trackingId) {
      const pagePath = location.pathname + location.search;
      
      // GAにページビューイベントを送信
      window.gtag('config', trackingId, {
        'page_path': pagePath,
        'page_location': window.location.href,
      });

      //console.log(`[GA] Page View Sent: ${pagePath}`);
    }
    
  }, [location, trackingId]); // location が変わるたびに実行される

  // トラッキング専用なので、UIはレンダリングしない
  return null;
};

export default GATracker;